import { useUserFeature } from "hooks/useUserFeature";
import { Navigate } from "react-router-dom";
import { routes } from "constants/routes";
import StripeWallet from "./StripeWallet";

export default function Wallet() {
  const { isWalletEnabled } = useUserFeature();
  return isWalletEnabled ? (
    <StripeWallet />
  ) : (
    <Navigate to={routes.HAULPAY_BROKER_MANAGE_PAY} replace />
  );
}
